import React, { useContext } from "react";

import { HandlerContext } from "components/lnb/LnbWrapper";

import plusIcon from "styles/common/img/common/plusicon.png";
import noteIcon from "styles/common/img/common/noteicon.png";
import coachIcon from "styles/common/img/common/coachicon.png";

const APP_CODE = ["COCH"];

const BUTTON_IMG = {
    PLAN: plusIcon,
    WANT: noteIcon,
    COCH: coachIcon,
};

function ButtonType({ buttonInfo, addBoxClass, drwrCode }) {
    const handlerContext = useContext(HandlerContext);

    const handleClickButton = () => {
        if (APP_CODE.indexOf(drwrCode) === -1) {
            handlerContext.clickMenuTypeCodeLINK(buttonInfo?.[0], drwrCode);
            return;
        }
    };

    return (
        <div className={"addBox " + addBoxClass} onClick={handleClickButton}>
            <div className="addBoximg fl">
                <img src={BUTTON_IMG[drwrCode]} />
            </div>
            <div className="addBoxtxt fl">{buttonInfo?.[0]?.NAME}</div>
        </div>
    );
}

export default ButtonType;
